export enum AuthenticationTypes {
  Default = 0,
  WebMobile = 1,
  ExternalApi = 2,
}

export enum CollectionTypes {
  ContactCollection = 7,
  ProgramCollection = 8,
  ProgramContactCollection = 9,
  ActivityContactCollection = 10
}

export enum DataStatus {
  Processed = 0,
  New = 1,
  Updated = 2,
  Deleted = 3,
}

export enum DataTypes {
  None = 0,
  String = 1,
  Integer = 2,
  Double = 3,
  DateTime = 4,
  TimeSpan = 5,
  Boolean = 6
}

export enum EvideFormStatus {
  Draft = 1,
  Published = 2,
  Archived = 3
}

export enum FormTypes {
  WebForm = 3,
  ContactForm = 7,
  RegistrationForm = 8,
  RegistrationCompleteForm = 9,
  ProgramForm = 10,
  ProgramContactForm = 12,
  ProgramContactCompleteForm = 13,
  ActivityForm = 14,
  ActivityContactForm = 15,
  ActivityContactCompleteForm = 16,
  ActivitySessionForm = 17,
  AttandanceForm = 18,
  ContactAttandanceForm = 19,
  SessionHistoryForm = 20,
  TaskReminderForm = 21,
  SystemLogForm = 22,
  QuestionnairesForm = 24,
  QuestionnaireHistoryForm = 25,
  OrganisationForm = 26,
  UserForm = 27,
  AllocatedContactForm = 28,
  FamilyForm = 29,
  ProgramEventForm = 30,
  WaitingListForm = 31,
  NonCaseLoadForm = 32,
  HelplineForm = 33,
  FamilyMemberForm = 34,
  ActionPlanForm = 35,
  KeyContactForm = 36,
  PropertyForm = 37,
  UnitForm = 38,
  OccupancyForm = 39,
  DurationSessionForm = 40
}

export enum InputControllerTypes {
  TextBox = 1,
  TextArea = 2,
  Numeric = 4,
  Dropdown = 8,
  RadioButtons = 16,
  Checkboxes = 32,
  DatePicker = 64,
  TimePicker = 128,
  DateTimePicker = 256,
  Toggle = 512,
  Checkbox = 1024,
  DropdownMulti = 2048,
  Label = 4096,
  DropdownWithExtraText = 8192,
  // A repeatable table: the field defines COLUMNS (each a sub-field type); at data entry the
  // user adds/deletes ROWS. Rendered by detail-info-repeatable-table. See RepeatableTableColumn.
  RepeatableTable = 16384
}

export enum ExpandableControllerInputTypes {
  TextBox = 1,
  TextArea = 2,
  Dropdown = 8,
  Label = 4096
}

export enum InputDataSourceTypes {
  StaticSingle = 1,
  StaticMulti = 3,
  DynamicSingle = 4,
  DynamicMulti = 5,
  DynamicReadOnly = 6
}

export enum InputTypes {
  SystemInput = 1,
  Code = 2,
  Parameter = 3,
  SqlColumnName = 4,
  SqlColumnValue = 5,
  InputParameter = 6,
}

export enum RuleTypes {
  DynamicSingle = 4,
  DynamicMulti = 5,
}

export enum DeleteActionType {
  DeleteNone = 0,
  DeleteSingle = 1,
  DeleteAll = 2
}

export enum ValueSortType {
  None = 0,
  Ascending = 1,
  Descending = 2
}